import { query } from './theme.utils';

export const theme = {
  palette: {
    blueBase: '#394BF6',
    blueDarken5: '#2332C7',

    pinkBase: '#FF72B0',

    whiteBase: '#FFFFFF',
    whiteDarken5: '#F7F7F8',
    whiteDarken10: '#ECECEC',

    blackLighten15: '#292929',
    blackLighten10: '#1A1A1A',
    blackLighten5: '#202023',
    blackBase: '#000000',

    grayLighten10: '#DFDFE1',
    grayLighten5: '#C8C8CD',
    grayBase: '#C4C4C4',
    grayDarken5: '#B7B7B7',

    navyGrayLighten25: '#E4E5E7',
    navyGrayLighten20: '#B6B6BC',
    navyGrayLighten15: '#9D9DA6',
    navyGrayLighten10: '#7D7D88',
    navyGrayLighten5: '#73737D',
    navyGrayBase: '#616170',
    navyGrayDarken5: '#55555D',
    navyGrayDarken10: '#4E4E55',
    navyGrayDarken15: '#303034',
    navyGrayDarken20: '#313135',
  },

  breakpoints: {
    maxMobile: query.maxMobile,
    minTablet: query.minTablet,
    tablet: query.tablet,
    maxTablet: query.maxTablet,
    minDesktop: query.minDesktop,
    desktop: query.desktop,
    maxDesktop: query.maxDesktop,
    minLarge: query.minLarge,
  },

  typography: {
    p: {
      sm: {
        fontSize: '1.2rem',
        lineHeight: 2,
        fontWeight: 400,
      },
      md: {
        fontSize: '1.4rem',
        lineHeight: '2.4rem',
        fontWeight: 400,
      },
      lg: {
        fontSize: '1.6rem',
        lineHeight: 2,
        fontWeight: 400,
      },
      xl: {
        fontSize: '2rem',
        lineHeight: 2,
        fontWeight: 400,
      },
    },

    h1: {
      sm: {
        fontSize: '2.8rem',
        fontWeight: 600,
        lineHeight: 1.3,
        letterSpacing: '-0.02em',
      },
      md: {
        fontSize: '4.8rem',
        fontWeight: 600,
        lineHeight: 1.3,
        letterSpacing: '-0.02em',
      },
    },
    h2: {
      sm: {
        fontSize: '1.6rem',
        fontWeight: '600',
        lineHeight: 1.3,
      },
      md: {
        fontSize: '2.8rem',
        fontWeight: '600',
        lineHeight: 1.3,
      },
    },
    h3: {
      md: {
        fontSize: '1.4rem',
        fontWeight: '600',
        lineHeight: '2.4rem',
      },
    },
  },
};
